import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bbb50fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "nav-path" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "投保采集详情")
], -1))
const _hoisted_5 = { class: "upper-section" }
const _hoisted_6 = { class: "content-wrapper" }
const _hoisted_7 = { class: "info-panel" }
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-item center-title" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1","text-align":"center","padding-right":"24px"} }, "当前标的")
], -1))
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "农户姓名：", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "投保单号：", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "标的号：", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "info-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "登记号：", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 0,
  class: "info-item"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "畜龄（月）：", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "info-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集位置：", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "info-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "GPS：", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = { class: "info-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集日期：", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "info-item collect-info-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集信息：", -1))
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "collect-info-grid" }
const _hoisted_39 = { class: "compare-result" }
const _hoisted_40 = { class: "result-container" }
const _hoisted_41 = { class: "result-content" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow-indicator" }, null, -1))
const _hoisted_43 = { class: "result-text" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "投保对比结果", -1))
const _hoisted_45 = { class: "image-panel" }
const _hoisted_46 = { class: "image-container" }
const _hoisted_47 = { class: "image-grid" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "pin-icon" }
const _hoisted_50 = {
  key: 0,
  class: "video-content",
  controls: "",
  style: {"width":"100%","height":"100%","object-fit":"contain"}
}
const _hoisted_51 = ["src"]
const _hoisted_52 = ["src", "alt"]
const _hoisted_53 = { class: "compare-toolbar" }
const _hoisted_54 = { class: "left-section" }
const _hoisted_55 = {
  key: 0,
  class: "cart-info"
}
const _hoisted_56 = { class: "compare-count" }
const _hoisted_57 = { class: "right-section" }
const _hoisted_58 = { class: "compare-items" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "lower-section" }
const _hoisted_61 = { class: "content-wrapper" }
const _hoisted_62 = { class: "info-panel" }
const _hoisted_63 = { class: "info-content" }
const _hoisted_64 = { class: "info-item center-title" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投保-对比标的", -1))
const _hoisted_66 = { class: "info-item" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "农户姓名：", -1))
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "info-item" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集订单号：", -1))
const _hoisted_71 = { class: "value" }
const _hoisted_72 = { class: "info-item" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "标的号：", -1))
const _hoisted_74 = { class: "value" }
const _hoisted_75 = { class: "info-item" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "登记号：", -1))
const _hoisted_77 = { class: "value" }
const _hoisted_78 = {
  key: 0,
  class: "info-item"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "畜龄（月）：", -1))
const _hoisted_80 = { class: "value" }
const _hoisted_81 = { class: "info-item" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集位置：", -1))
const _hoisted_83 = { class: "value" }
const _hoisted_84 = { class: "info-item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "GPS：", -1))
const _hoisted_86 = { class: "value" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_88 = { class: "info-item" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集日期：", -1))
const _hoisted_90 = { class: "value" }
const _hoisted_91 = { class: "info-item collect-info-item" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "采集信息：", -1))
const _hoisted_93 = { class: "value" }
const _hoisted_94 = { class: "collect-info-grid" }
const _hoisted_95 = { class: "image-panel" }
const _hoisted_96 = { class: "image-container" }
const _hoisted_97 = { class: "image-grid" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "pin-icon" }
const _hoisted_100 = {
  key: 0,
  class: "video-content",
  controls: "",
  style: {"width":"100%","height":"100%","object-fit":"contain"}
}
const _hoisted_101 = ["src"]
const _hoisted_102 = ["src", "alt"]

import { ref, computed, onMounted, nextTick, watch, onBeforeUnmount } from 'vue'
import { ArrowLeft, ArrowRight, CloseBold } from '@element-plus/icons-vue'
import incImgSvg from './incImgSvg.vue'
import { useRoute, useRouter } from 'vue-router'
import { appTargetDetail } from '@/views/VerificationData/api.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { targetAudit } from "../../api";
import { ElLoading } from 'element-plus'
import { showWarningAlert } from '@/utiles/message';
import { getCompanyOption } from "@/views/VerificationData/api.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessPage',
  setup(__props) {

const pageLoading = ref<any>(null)
const selectRef = ref(null)
const router = useRouter()
const route = useRoute()
const compareResult = ref('')
const tagStatus = ref('')
const targetType = ref(route.query.name || '')
const activeType = ref('')
const currentIndex = ref(0)
const fixedStates = ref(new Map())
const currentCompareIndex = ref(0) // 当前选中的比较项索引
const onlyShowCompare = ref(false)
const compareStartIndex = ref(0)
const itemsPerPage = 10 // 每页显示的对比项数量
const fixedLimit = 3; // 固定图片的最大数量
const currentLowerIndex = ref(0)
const fixedStatesLower = ref(new Map())
const selectedCompareItems = ref(new Set())
const confirmedTargetId = ref(''); // 存储已确认的标的ID
const isReadonly = computed(() => route.query.readonly === 'true')
const isItemSelected = computed(() => {
    const currentItem = simImages.value[currentCompareIndex.value];
    return currentItem ? selectedCompareItems.value.has(currentItem.id) : false;
});
// 下半部分的状态管理
const activeTypeLower = ref('front') // 默认显示正脸
const goBack = () => {
    router.back()
}
const collectTypes = [
    { label: '正脸', value: 'FACE' },
    { label: '左侧脸', value: 'LEFT_FACE' },
    { label: '右侧脸', value: 'RIGHT_FACE' },
    { label: '鼻纹', value: 'NOSE' },
    { label: '其他照片', value: 'OTHER' },
    { label: '视频', value: 'VIDEO' }
]
const userInfo = sessionStorage.getItem("userInfo")
  ? JSON.parse(sessionStorage.getItem("userInfo") || "")
  : null;
const validateInsureConfig = async (typeEnum: string, collectField: string): Promise<boolean> => {
  if (!userInfo?.compCode) {
    console.warn('用户信息中缺少 compCode');
    return false;
  }
  
  try {
    const companyInfoConfigs = await getCompanyOption(userInfo.compCode);
    // 1. 找到类型为 INSURE 的配置项
    const insureConfig = companyInfoConfigs?.verificationCollection?.find(
      item => item.typeEnum === typeEnum
    );
    
    if (!insureConfig) {
      console.warn('未找到 ' + typeEnum + ' 类型的配置');
      return false;
    }
    
    // 2. 获取 companyOptionObj
    const companyOptionObj = insureConfig.companyOptionObj;
    if (!companyOptionObj) {
      console.warn(typeEnum + ' 配置中缺少 companyOptionObj');
      return false;
    }
    
    // 3. 获取 collectFields 数组
    const collectFields = companyOptionObj.collectFields;
    if (!Array.isArray(collectFields) || collectFields.length === 0) {
      console.warn('collectFields 为空或不是数组');
      return false;
    }
    
    // 4. 检查是否包含指定字段
    const hasCollectField = collectFields.some(
      field => field.field === collectField
    );
    
    console.log('是否包含 ' + collectField + ' 字段:', hasCollectField);
    return hasCollectField;
    
  } catch (error: any) {
    console.error("Error fetching company options:", error);
    return false;
  }
};
const showField = ref(false);

onMounted(async () => {
  showField.value = await validateInsureConfig('INSURANCE','LIVESTOCK_AGE');
});
const availableTypes = computed(() => {
    const types = new Set();

    // 添加主要图片类型
    res.value?.targetInfo?.picInfoVoList?.forEach(item => {
        if (item.fileIds?.length > 0) {
            types.add(item.picType);
        }
    });

    // 添加其他照片类型
    if (res.value?.targetInfo?.otherFileInfoVoList?.some(item => item.fileType !== 1)) {
        types.add('OTHER');
    }

    // 添加视频类型
    if (res.value?.targetInfo?.otherFileInfoVoList?.some(item => item.fileType === 1)) {
        types.add('VIDEO');
    }

    // 返回过滤后的collectTypes
    return collectTypes.filter(type => types.has(type.value));
});
// 先定义一个固定的类型顺序常量
const TYPE_ORDER = ['FACE', 'LEFT_FACE', 'RIGHT_FACE', 'NOSE', 'OTHER', 'VIDEO'];

const getProcessedImages = computed(() => {
    const images = [];
    const tempImages = new Map(); // 用于临时存储各类型的图片

    // 初始化每种类型的数组
    TYPE_ORDER.forEach(type => {
        tempImages.set(type, []);
    });

    // 处理主要类型图片（正脸、左侧脸、右侧脸、鼻纹）
    res.value?.targetInfo?.picInfoVoList?.forEach(picInfo => {
        if (picInfo.fileIds) {
            picInfo.fileIds.forEach((file, index) => {
                const image = {
                    id: `${picInfo.picType}_${index}`,
                    url: file.cloudServiceType === '1' ?
                        res.value.ossUrl + file.url :
                        res.value.cosUrl + file.url,
                    type: picInfo.picType,
                    fixed: fixedStates.value.get(`${picInfo.picType}_${index}`) || false
                };

                // 将图片添加到对应类型的数组中
                if (tempImages.has(picInfo.picType)) {
                    tempImages.get(picInfo.picType).push(image);
                }
            });
        }
    });

    // 处理其他照片
    res.value?.targetInfo?.otherFileInfoVoList?.forEach((item, groupIndex) => {
        if (item.fileIds) {
            if (item.fileType !== 1) { // 非视频文件
                item.fileIds.forEach((file, fileIndex) => {
                    const image = {
                        id: `OTHER_${groupIndex}_${fileIndex}`,
                        url: file.cloudServiceType === '1' ?
                            res.value.ossUrl + file.url :
                            res.value.cosUrl + file.url,
                        type: 'OTHER',
                        fixed: fixedStates.value.get(`OTHER_${groupIndex}_${fileIndex}`) || false
                    };
                    tempImages.get('OTHER').push(image);
                });
            } else { // 视频文件
                item.fileIds.forEach((file, fileIndex) => {
                    const image = {
                        id: `VIDEO_${groupIndex}_${fileIndex}`,
                        url: file.cloudServiceType === '1' ?
                            res.value.ossUrl + file.url :
                            res.value.cosUrl + file.url,
                        type: 'VIDEO',
                        fixed: fixedStates.value.get(`VIDEO_${groupIndex}_${fileIndex}`) || false
                    };
                    tempImages.get('VIDEO').push(image);
                });
            }
        }
    });

    // 按照指定顺序合并所有图片
    TYPE_ORDER.forEach(type => {
        const typeImages = tempImages.get(type);
        if (typeImages && typeImages.length > 0) {
            images.push(...typeImages);
        }
    });

    return images;
});

const simImages = computed(() => {
    if (!res.value?.simTarget) return [];

    return res.value.simTarget.map(target => ({
        id: target.id,
        targetNo: target.targetNo,
        sim: target.sim,
        farmerName: target.farmerName,
        orderNo: target.orderNo,
        earNo: target.earNo || target.collarBarcode,
        location: target.collectAddr,
        longitude: target.collectLocation?.split(',')[0] || '-',
        latitude: target.collectLocation?.split(',')[1] || '-',
        collectDate: target.created,
        picInfoVoList: target.picInfoVoList || [],
        otherFileInfoVoList: target.otherFileInfoVoList || [],
        livestockAge: target.livestockAge || '-'
    }));
});
const compareCount = computed(() => {
    return selectedCompareItems.value.size;
});
const handleItemClick = (item, index) => {
    // 如果是只看对比项模式，需要找到真实的索引
    if (onlyShowCompare.value) {
        const realIndex = simImages.value.findIndex(i => i.id === item.id);
        currentCompareIndex.value = realIndex;
    } else {
        currentCompareIndex.value = compareStartIndex.value + index;
    }
};
// 显示序号
const getDisplayIndex = (item, index) => {
    if (onlyShowCompare.value) {
        // 在只看对比项模式下，找到项目在原数组中的位置
        return simImages.value.findIndex(i => i.id === item.id) + 1;
    } else {
        return compareStartIndex.value + index + 1;
    }
};
// 存储获取localStorage
const saveCompareItems = (targetId: string, items: Set<string>) => {
    localStorage.setItem(`compareItems:${targetId}`, JSON.stringify(Array.from(items)));
};
const handleOnlyShowCompareChange = (val: boolean) => {
    nextTick(() => {
        if (val && selectedCompareItems.value.size === 0) {
            ElMessage.warning('请先选择需要对比的项目');
            onlyShowCompare.value = false;
            return;
        }
    });
};
const handleClearAllCompare = () => {
    if (selectedCompareItems.value.size === 0) {
        ElMessage.warning('当前没有对比项');
        return;
    }

    ElMessageBox.confirm(
        '确定要清除所有对比项吗？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }
    ).then(() => {
        // 清除所有选中的对比项
        selectedCompareItems.value.clear();

        // 清除localStorage中的对比项
        const targetId = route.query.id as string;
        localStorage.removeItem(`compareItems:${targetId}`);

        // 如果当前是只看对比项模式就关闭
        if (onlyShowCompare.value) {
            onlyShowCompare.value = false;
        }

        // 重置当前索引到第一项
        currentCompareIndex.value = 0;
        compareStartIndex.value = 0;

        ElMessage.success('已清除所有对比项');
    }).catch(() => {
        // 用户取消操作，不做任何处理
    });
};
const getCompareItems = (targetId: string): Set<string> => {
    const savedItems = localStorage.getItem(`compareItems:${targetId}`);
    if (savedItems) {
        return new Set(JSON.parse(savedItems));
    }
    return new Set();
};
const handleCompareToggle = () => {
    const currentItem = simImages.value[currentCompareIndex.value];
    if (!currentItem) return;

    const targetId = route.query.id as string;

    if (selectedCompareItems.value.has(currentItem.id)) {
        // 取消对比
        selectedCompareItems.value.delete(currentItem.id);
        saveCompareItems(targetId, selectedCompareItems.value);

        // 如果是在"只看对比项"模式下
        if (onlyShowCompare.value) {
            // 检查是否还有其他对比项
            if (selectedCompareItems.value.size > 0) {
                // 找到下一个对比项的索引
                const nextCompareItemIndex = simImages.value.findIndex(item =>
                    item.id !== currentItem.id && selectedCompareItems.value.has(item.id)
                );
                if (nextCompareItemIndex !== -1) {
                    currentCompareIndex.value = nextCompareItemIndex;
                }
            } else {
                // 如果没有任何对比项了，取消"只看对比项"
                onlyShowCompare.value = false;
                // 重置到当前项
                currentCompareIndex.value = simImages.value.findIndex(item =>
                    item.id === currentItem.id
                );
            }
        }
    } else {
        // 加入对比
        selectedCompareItems.value.add(currentItem.id);
        saveCompareItems(targetId, selectedCompareItems.value);
    }
};
const shouldHideAuditButton = computed(() => {
  return route.query.hideAuditButton === 'true';
});
const getCompareItemClass = (item) => {
    return {
        'compare-item': true,
        'active': item.id === simImages.value[currentCompareIndex.value]?.id,
        'selected': selectedCompareItems.value.has(item.id)
    };
};
// 是否禁用重复标的选项
const isRepeatDisabled = computed(() => {
    const targetData = [
        ...(res.value?.simTarget || []),
        ...(res.value?.simTargetLow || [])
    ];
    // 在 AuditPage 页面且承保库对比结果为唯一标的时，强制禁用重复标的选项
    if (route.query.name === 'AuditPage' && res.value?.targetInfo?.targetStatus === 'NORMAL') {
        return true;
    }
    // 其他情况保持原有逻辑
    return res.value?.targetInfo?.targetStatus !== 'REPEAT' && targetData.length === 0;
});
const displayCompareItems = computed(() => {
    // 先判断是否是只读的已审核页面
    const isAuditedReadOnly = route.query.readonly === 'true' && route.query.name === 'audited';

    // 基于是否只看对比项进行第一次过滤
    let filteredItems = onlyShowCompare.value
        ? simImages.value.filter(item => selectedCompareItems.value.has(item.id))
        : simImages.value;

    // 如果是已审核的只读页面，只显示已确认的标的
    if (isAuditedReadOnly && res.value?.targetInfo?.insureSimilarId) {
        filteredItems = filteredItems.filter(item => item.id === res.value.targetInfo.insureSimilarId);
    }

    // 进行分页
    const start = compareStartIndex.value;
    const end = Math.min(start + itemsPerPage, filteredItems.length);
    return filteredItems.slice(start, end);
});
// 计算是否可以前后翻页
const canGoPreviousCompare = computed(() => {
    return compareStartIndex.value > 0
})
const canGoNextCompare = computed(() => {
    const totalItems = onlyShowCompare.value
        ? selectedCompareItems.value.size
        : simImages.value.length;
    return compareStartIndex.value + itemsPerPage < totalItems;
});
// 翻页
const previousCompareItems = () => {
    if (canGoPreviousCompare.value) {
        compareStartIndex.value = Math.max(0, compareStartIndex.value - itemsPerPage);
    }
};
const nextCompareItems = () => {
    if (canGoNextCompare.value) {
        const totalItems = onlyShowCompare.value
            ? selectedCompareItems.value.size
            : simImages.value.length;
        compareStartIndex.value = Math.min(
            totalItems - itemsPerPage,
            compareStartIndex.value + itemsPerPage
        );
    }
};
// 添加用于计算按钮状态的计算属性
const canGoNext = computed(() => {
    const nonFixed = nonFixedImages.value;
    const fixedCount = fixedImages.value.length;
    const remainingCount = 4 - fixedCount;

    // 确保下一页有完整的图片可以显示
    return currentIndex.value < Math.max(0, nonFixed.length - remainingCount);
});

const canGoPrevious = computed(() => {
    return currentIndex.value > 0;
});
// 翻页
const nextImage = () => {
    if (canGoNext.value) {
        const nonFixed = nonFixedImages.value;
        const fixedCount = fixedImages.value.length;
        const remainingCount = 4 - fixedCount;

        // 计算下一页的索引，确保显示完整的图片
        const nextIndex = Math.min(
            currentIndex.value + 1,
            Math.max(0, nonFixed.length - remainingCount)
        );
        currentIndex.value = nextIndex;
    }
};

const previousImage = () => {
    if (canGoPrevious.value) {
        currentIndex.value = Math.max(0, currentIndex.value - 1);
    }
};
// 切换图片类型
const switchType = (type: string) => {
    activeType.value = type;
    const nonFixed = nonFixedImages.value;
    const fixedCount = fixedImages.value.length;

    // 找到第一张目标类型图片的索引
    const targetIndex = nonFixed.findIndex(img => img.type === type);

    if (targetIndex >= 0) {
        // 调整显示位置确保完整显示4张图片
        const maxIndex = Math.max(0, nonFixed.length - (4 - fixedCount));
        currentIndex.value = Math.min(targetIndex, maxIndex);
    } else {
        currentIndex.value = 0;
    }
};

const completeCheck = async () => {
    if (!compareResult.value) {
        // ElMessage.warning('请先选择对比结果');
        showWarningAlert('请先选择对比结果')
        return;
    }

    if (compareResult.value === 'REPEAT' && !confirmedTargetId.value) {
        // ElMessage.warning('当前投保对比结果选择为重复标的，请选择对应的标的');
        showWarningAlert('当前投保对比结果选择为重复标的，请选择对应的标的')
        return;
    }

    const condition = {
        auditStatus: compareResult.value,  // 'REPEAT'  'NORMAL'
            auditTargetId: confirmedTargetId.value, // 已确认的对比标的ID
            targetId: route.query.id as string, // 当前标的ID
            type: 'SUBJECT'  // 固定的
    }
    ElMessageBox.confirm('是否确认审核结果', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
        handleTargetAudit(condition)
    }).catch(() => {
      // 用户取消操作，不做任何处理
    });
};
const handleTargetAudit = async (condition:any) => {
    try {
        await targetAudit(condition);

        // 清除localStorage
        const targetId = route.query.id as string;
        localStorage.removeItem(`compareItems:${targetId}`);

        ElMessage.success('审核完成');
        router.back();
    } catch (error) {
        console.error('完成审核失败:', error);
        // ElMessage.error('审核失败，请重试');
    }
}
const handleConfirmTarget = () => {
    const currentItem = simImages.value[currentCompareIndex.value];
    if (!currentItem) return;

    // 如果当前项就是已确认的项
    if (confirmedTargetId.value === currentItem.id) {
        ElMessageBox.confirm(
            '是否取消确认该标的？',
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        )
            .then(() => {
                confirmedTargetId.value = '';
                ElMessage({
                    type: 'success',
                    message: '已取消确认'
                });
            })
            .catch(() => { });
    } else {
        // 确认新标的的逻辑
        let message = '确认选择该标的作为对比标的？';
        if (confirmedTargetId.value) {
            message = '已有确认的标的，是否改为确认当前标的？';
        }

        ElMessageBox.confirm(
            message,
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        )
            .then(() => {
                confirmedTargetId.value = currentItem.id;
                ElMessage({
                    type: 'success',
                    message: '已确认标的'
                });
            })
            .catch(() => { });
    }
};
const showAuditButton = computed(() => {
    return targetType.value === 'AuditPage' && !isReadonly.value;
});

// 计算固定的图片，但只包含当前选中类型的图片
const fixedImages = computed(() => {
    // 获取所有固定的图片，不再根据 activeType 过滤
    const fixedImagesMap = new Map();
    getProcessedImages.value.forEach(image => {
        if (image.fixed) {
            // 使用 fixedStates 中的设置时间作为排序依据
            const fixedTime = fixedStates.value.get(image.id);
            if (fixedTime) {
                fixedImagesMap.set(image.id, {
                    ...image,
                    fixedTime
                });
            }
        }
    });

    // 按照固定时间排序并返回结果
    return Array.from(fixedImagesMap.values())
        .sort((a, b) => a.fixedTime - b.fixedTime)
        .slice(0, fixedLimit);
});
// 计算未固定的图片，同样只包含当前选中类型的图片
const nonFixedImages = computed(() => {
    // 直接返回未固定的图片，保持原始顺序
    return getProcessedImages.value.filter(image => !image.fixed);
});
// 显示图片计算
const displayImages = computed(() => {
    const fixed = fixedImages.value;
    const fixedCount = fixed.length;
    const nonFixed = nonFixedImages.value;

    // 计算需要显示的非固定图片数量
    const remainingCount = 4 - fixedCount;

    // 调整 currentIndex 以确保始终显示4张图片（如果有足够的图片）
    if (currentIndex.value > Math.max(0, nonFixed.length - remainingCount)) {
        currentIndex.value = Math.max(0, nonFixed.length - remainingCount);
    }

    // 获取要显示的非固定图片
    const displayNonFixed = nonFixed.slice(
        currentIndex.value,
        currentIndex.value + remainingCount
    );

    return [...fixed, ...displayNonFixed];
});
const toggleFix = (image) => {
    const currentFixed = fixedStates.value.get(image.id);

    if (currentFixed) {
        fixedStates.value.delete(image.id);
    } else {
        const fixedCount = Array.from(fixedStates.value.values()).filter(x => x).length;
        if (fixedCount < fixedLimit) {
            // 使用时间戳记录固定顺序
            fixedStates.value.set(image.id, Date.now());
        } else {
            ElMessage.warning(`最多只能固定${fixedLimit}张图片`);
        }
    }
};
// 判断当前项是否是已确认的标的
const isCurrentItemConfirmed = computed(() => {
    const currentItem = simImages.value[currentCompareIndex.value];
    return currentItem && confirmedTargetId.value === currentItem.id;
});
const targetInfo = ref({
    farmerName: '',  // 农户姓名
    policyNo1: '',   // 政策投保单号
    policyNo2: '',   // 商业投保单号
    targetNo: '',    // 标的号
    earNo: '',       // 耳标号
    collarBarcode: '', // 项圈号
    collectAddr: '', // 采集位置
    collectLocation: '', // GPS
    created: '',      // 采集日期
    orderNo: '',       // 订单号改成了投保单号
    livestockAge: '', // 畜龄（月）
})
const res = ref(null);
const appTargetDetailFn = async (id: string) => {
    pageLoading.value = ElLoading.service({
        lock: true,
        text: '数据加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
    try {
        const response = await appTargetDetail(id);
        if (response) {
            res.value = response;

            if (response.targetInfo) {
                // compareResult.value = response.targetInfo.insureResult || '';

                compareResult.value = response.targetInfo.insureResult ||
                    (response.targetInfo.targetStatus === 'REPEAT' ? 'REPEAT' : 'NORMAL')

                tagStatus.value = response.targetInfo.targetStatus || '';

                // 如果有已确认的标的
                if (response.targetInfo.insureSimilarId) {
                    confirmedTargetId.value = response.targetInfo.insureSimilarId;
                }
            }

            targetInfo.value = {
                farmerName: response.targetInfo?.farmerName || '-',
                policyNo1: response.targetInfo?.policyNo1 || '-',
                policyNo2: response.targetInfo?.policyNo2 || '-',
                targetNo: response.targetInfo?.targetNo || '-',
                earNo: response.targetInfo?.earNo || null,
                collarBarcode: response.targetInfo?.collarBarcode || '-',
                collectAddr: response.targetInfo?.collectAddr || '-',
                collectLocation: response.targetInfo?.collectLocation || '',
                created: response.targetInfo?.created || '-',
                orderNo: response.targetInfo?.orderNo || '-',
                livestockAge: response.targetInfo?.livestockAge || '-'
            }
        }
    } catch (error) {
        console.error('获取数据失败:', error);
    } finally {
        pageLoading.value?.close()
    }
};
const handleScroll = () => {
    // 确保 select 存在
    if (selectRef.value) {
        selectRef.value.blur(); // 让 select 失去焦点
        selectRef.value.handleClose(); // 关闭下拉菜单
    }
};
onBeforeUnmount(() => {
    const targetId = route.query.id as string;
    saveCompareItems(targetId, selectedCompareItems.value);
    // 清理确认标的状态
    confirmedTargetId.value = '';
    pageLoading.value?.close()
    document.removeEventListener('scroll', handleScroll, true);
});
onMounted(() => {
    const targetId = route.query.id as string
    appTargetDetailFn(targetId).then(() => {
        // 在数据加载完成后，如果有insureSimilarId，自动设置为已确认标的
        if (res.value?.targetInfo?.insureSimilarId) {
            confirmedTargetId.value = res.value.targetInfo.insureSimilarId;

            // 如果是重复标的，找到已确认标的的索引并设置
            if (res.value.targetInfo.targetStatus === 'REPEAT') {
                const confirmedIndex = res.value.simTarget.findIndex(
                    item => item.id === res.value.targetInfo.insureSimilarId
                );
                if (confirmedIndex !== -1) {
                    currentCompareIndex.value = confirmedIndex;
                }
            }
        }
    });

    // 从localStorage恢复对比项
    const savedItems = getCompareItems(targetId);
    if (savedItems.size > 0) {
        selectedCompareItems.value = savedItems;
    }

    // 监听容器的滚动
    document.addEventListener('scroll', handleScroll, true);
})
// 计算属性来获取可用的类型
const availableTypesLower = computed(() => {
    const currentImage = simImages.value[currentCompareIndex.value];
    if (!currentImage?.picInfoVoList) return [];

    const types = new Set();

    // 按照指定顺序检查和添加可用类型
    TYPE_ORDER.forEach(type => {
        // 检查主要类型
        const hasPicType = currentImage.picInfoVoList.some(
            info => info.picType === type && info.fileIds?.length > 0
        );
        if (hasPicType) {
            types.add(type);
        }

        // 检查其他照片和视频
        if (type === 'OTHER' || type === 'VIDEO') {
            const hasOtherOrVideo = currentImage.otherFileInfoVoList?.some(info =>
                info.fileIds?.length > 0 &&
                ((type === 'OTHER' && info.fileType !== 1) ||
                    (type === 'VIDEO' && info.fileType === 1))
            );
            if (hasOtherOrVideo) {
                types.add(type);
            }
        }
    });

    return collectTypes.filter(type => types.has(type.value));
});
const getProcessedLowerImages = (currentImage) => {
    if (!currentImage) return [];
    const images = [];

    // 按照指定顺序处理图片
    TYPE_ORDER.forEach(type => {
        // 找到对应类型的图片组
        const picInfo = currentImage.picInfoVoList?.find(info => info.picType === type);
        if (picInfo?.fileIds) {
            picInfo.fileIds.forEach((fileId, fileIndex) => {
                images.push({
                    id: `${currentCompareIndex.value}_${type}_${fileIndex}`,
                    url: fileId.cloudServiceType === '1' ?
                        res.value.ossUrl + fileId.url :
                        res.value.cosUrl + fileId.url,
                    type: type,
                    fixed: fixedStatesLower.value.get(`${currentCompareIndex.value}_${type}_${fileIndex}`) || false
                });
            });
        }

        // 处理其他照片和视频
        if (type === 'OTHER' || type === 'VIDEO') {
            currentImage.otherFileInfoVoList?.forEach((info, groupIndex) => {
                if (info.fileIds &&
                    ((type === 'OTHER' && info.fileType !== 1) ||
                        (type === 'VIDEO' && info.fileType === 1))) {
                    info.fileIds.forEach((fileId, fileIndex) => {
                        images.push({
                            id: `${currentCompareIndex.value}_${type}_${groupIndex}_${fileIndex}`,
                            url: fileId.cloudServiceType === '1' ?
                                res.value.ossUrl + fileId.url :
                                res.value.cosUrl + fileId.url,
                            type: type,
                            fixed: fixedStatesLower.value.get(`${currentCompareIndex.value}_${type}_${groupIndex}_${fileIndex}`) || false
                        });
                    });
                }
            });
        }
    });

    return images;
};
const switchTypeLower = (type: string) => {
    activeTypeLower.value = type;
    const nonFixed = nonFixedImagesLower.value;
    const fixedCount = fixedImagesLower.value.length;

    // 找到第一张目标类型图片的索引
    const targetIndex = nonFixed.findIndex(img => img.type === type);

    if (targetIndex >= 0) {
        // 调整显示位置确保完整显示4张图片
        const maxIndex = Math.max(0, nonFixed.length - (4 - fixedCount));
        currentLowerIndex.value = Math.min(targetIndex, maxIndex);
    } else {
        currentLowerIndex.value = 0;
    }
};
const displayImagesLower = computed(() => {
    const fixed = fixedImagesLower.value;
    const fixedCount = fixed.length;
    const nonFixed = nonFixedImagesLower.value;

    // 计算需要显示的非固定图片数量
    const remainingCount = 4 - fixedCount;

    // 调整索引以确保始终显示4张图片
    if (currentLowerIndex.value > Math.max(0, nonFixed.length - remainingCount)) {
        currentLowerIndex.value = Math.max(0, nonFixed.length - remainingCount);
    }

    // 获取要显示的非固定图片
    const displayNonFixed = nonFixed.slice(
        currentLowerIndex.value,
        currentLowerIndex.value + remainingCount
    );

    return [...fixed, ...displayNonFixed];
});
const toggleFixLower = (image) => {
    const currentFixed = fixedStatesLower.value.get(image.id);

    if (currentFixed) {
        fixedStatesLower.value.delete(image.id);
    } else {
        const fixedCount = Array.from(fixedStatesLower.value.values()).filter(x => x).length;
        if (fixedCount < 3) {
            // 使用当前时间戳记录固定顺序
            fixedStatesLower.value.set(image.id, Date.now());
        } else {
            ElMessage.warning('最多只能固定3张图片');
        }
    }
};
// 修改翻页按钮的禁用状态计算
const canGoNextLower = computed(() => {
    const nonFixed = nonFixedImagesLower.value;
    const fixedCount = fixedImagesLower.value.length;
    const remainingCount = 4 - fixedCount;

    // 确保下一页有完整的图片可以显示
    return currentLowerIndex.value < Math.max(0, nonFixed.length - remainingCount);
});

const canGoPreviousLower = computed(() => {
    return currentLowerIndex.value > 0;
});
// 图片切换
const nextImageLower = () => {
    if (canGoNextLower.value) {
        const nonFixed = nonFixedImagesLower.value;
        const fixedCount = fixedImagesLower.value.length;
        const remainingCount = 4 - fixedCount;

        // 计算下一页的索引，确保显示完整的图片
        const nextIndex = Math.min(
            currentLowerIndex.value + 1,
            Math.max(0, nonFixed.length - remainingCount)
        );
        currentLowerIndex.value = nextIndex;
    }
};

const previousImageLower = () => {
    if (canGoPreviousLower.value) {
        currentLowerIndex.value = Math.max(0, currentLowerIndex.value - 1);
    }
};
const fixedImagesLower = computed(() => {
    const fixedImagesMap = new Map();
    const allImages = getProcessedLowerImages(simImages.value[currentCompareIndex.value]);

    allImages.forEach(image => {
        if (fixedStatesLower.value.get(image.id)) {
            // 使用固定的时间戳作为排序依据
            const fixedTime = fixedStatesLower.value.get(image.id);
            fixedImagesMap.set(image.id, {
                ...image,
                fixedTime
            });
        }
    });

    // 按照固定时间排序
    return Array.from(fixedImagesMap.values())
        .sort((a, b) => a.fixedTime - b.fixedTime)
        .slice(0, 3); // 限制最多3张固定图片
});
const nonFixedImagesLower = computed(() => {
    const currentItem = simImages.value[currentCompareIndex.value];
    if (!currentItem) return [];

    // 获取所有图片并保持原始顺序
    const allImages = getProcessedLowerImages(currentItem);
    return allImages.filter(img => !fixedStatesLower.value.get(img.id));
});

watch(currentCompareIndex, () => {
    fixedStatesLower.value.clear();
    currentLowerIndex.value = 0;
});
watch(onlyShowCompare, (newVal) => {
    nextTick(() => {
        // 当开启"只看对比项"时检查是否有选中的项目
        if (newVal && selectedCompareItems.value.size === 0) {
            ElMessage.warning('请先选择需要对比的项目');
            nextTick(() => {
                onlyShowCompare.value = false;
            });
            return;
        }

        // 重置起始索引
        compareStartIndex.value = 0;

        if (newVal) {
            const currentItem = simImages.value[currentCompareIndex.value];
            // 如果当前项不在对比列表中,则切换到对比列表的第一个项目
            if (currentItem && !selectedCompareItems.value.has(currentItem.id)) {
                // 找到第一个加入对比的项目的索引
                const firstCompareItemIndex = simImages.value.findIndex(item =>
                    selectedCompareItems.value.has(item.id)
                );
                if (firstCompareItemIndex !== -1) {
                    currentCompareIndex.value = firstCompareItemIndex;
                }
            }
        }
    });
}, { immediate: true }); // 主要为了确保首次渲染时也执行
watch(compareResult, (newValue) => {
    if (newValue === 'NORMAL') {
        // 清除已确认的标的ID
        confirmedTargetId.value = '';
    } else if (newValue === 'REPEAT' && res.value?.targetInfo?.insureSimilarId) {
        // 如果切换到重复标的且有已确认标的，恢复之前的确认状态
        confirmedTargetId.value = res.value.targetInfo.insureSimilarId;

        // 找到已确认标的的索引并设置
        const confirmedIndex = res.value.simTarget.findIndex(
            item => item.id === res.value.targetInfo.insureSimilarId
        );
        if (confirmedIndex !== -1) {
            currentCompareIndex.value = confirmedIndex;
        }
    }
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          link: "",
          onClick: goBack,
          class: "back-button"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            }),
            _createTextVNode(" 返回 ")
          ]),
          _: 1
        }),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(targetInfo.value.farmerName), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(targetInfo.value.orderNo), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(targetInfo.value.targetNo), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, _toDisplayString(targetInfo.value.earNo || targetInfo.value.collarBarcode), 1)
            ]),
            (showField.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(targetInfo.value.livestockAge || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, _toDisplayString(targetInfo.value.collectAddr), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, [
                _createTextVNode(" 经度 " + _toDisplayString(targetInfo.value.collectLocation.split(',')[0]), 1),
                _hoisted_31,
                _createTextVNode(" 纬度 " + _toDisplayString(targetInfo.value.collectLocation.split(',')[1]), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(targetInfo.value.created), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTypes), (type) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "button-container",
                      key: type.value
                    }, [
                      _createVNode(_component_el_button, {
                        class: _normalizeClass(['info-button', { active: activeType.value === type.value }]),
                        onClick: ($event: any) => (switchType(type.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_el_select, {
                      ref_key: "selectRef",
                      ref: selectRef,
                      modelValue: compareResult.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compareResult).value = $event)),
                      placeholder: "请选择",
                      class: "result-select",
                      disabled: _unref(isReadonly)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "重复标的",
                          value: "REPEAT",
                          disabled: _unref(isRepeatDisabled)
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_el_option, {
                          label: "唯一标的",
                          value: "NORMAL"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]),
                    (!_unref(isReadonly) && _unref(route).query.name !== 'COLLECTING' && !_unref(shouldHideAuditButton))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: completeCheck
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完成审核")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_el_button, {
              class: "nav-button prev",
              onClick: previousImage,
              disabled: !_unref(canGoPrevious)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowLeft))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "nav-button next",
              onClick: nextImage,
              disabled: !_unref(canGoNext)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowRight))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_47, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImages), (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'pin-' + image.id,
                  class: "pin-container",
                  style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` }),
                  onClick: ($event: any) => (toggleFix(image))
                }, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("i", {
                      class: _normalizeClass(image.fixed ? 'fixed-icon-class' : 'pin-icon-class')
                    }, null, 2)
                  ])
                ], 12, _hoisted_48))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImages), (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: image.id,
                  class: "image-wrapper",
                  style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` })
                }, [
                  (image.type === 'VIDEO')
                    ? (_openBlock(), _createElementBlock("video", _hoisted_50, [
                        _createElementVNode("source", {
                          src: image.url,
                          type: "video/mp4"
                        }, null, 8, _hoisted_51),
                        _createTextVNode(" Your browser does not support the video tag. ")
                      ]))
                    : (_openBlock(), _createBlock(incImgSvg, {
                        key: 1,
                        class: "image-zoom-container",
                        "dialog-visible": false,
                        "img-width": "100%",
                        "img-src": image.url
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: image.url,
                            alt: 'Image ' + image.id
                          }, null, 8, _hoisted_52)
                        ]),
                        _: 2
                      }, 1032, ["img-src"]))
                ], 4))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        (!_unref(isReadonly))
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(onlyShowCompare.value ? 'ShoppingCartFull' : 'ShoppingCart')))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_56, [
                _createTextVNode(" 对比项："),
                _createElementVNode("span", {
                  class: _normalizeClass({ 'blue-text': _unref(compareCount) > 0 })
                }, _toDisplayString(_unref(compareCount)) + "头", 3)
              ]),
              _createVNode(_component_el_icon, {
                class: "clear-icon",
                onClick: handleClearAllCompare
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CloseBold))
                ]),
                _: 1
              }),
              _createVNode(_component_el_checkbox, {
                modelValue: onlyShowCompare.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((onlyShowCompare).value = $event)),
                onChange: handleOnlyShowCompareChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode("只看对比项")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_el_button, {
          class: "nav-button prev",
          onClick: previousCompareItems,
          disabled: !_unref(canGoPreviousCompare)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_el_row, {
            type: "flex",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayCompareItems), (item, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(getCompareItemClass(item)),
                      onClick: ($event: any) => (handleItemClick(item, index))
                    }, _toDisplayString(getDisplayIndex(item, index)) + " (" + _toDisplayString((item.sim * 100).toFixed(0)) + "%) ", 11, _hoisted_59)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_button, {
          class: "nav-button next",
          onClick: nextCompareItems,
          disabled: !_unref(canGoNextCompare)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        (!_unref(isReadonly))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "add-compare-btn",
              onClick: handleCompareToggle
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(isItemSelected) ? '取消对比' : '加入对比'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, compareResult.value === 'REPEAT']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createVNode(_component_el_button, {
                disabled: _unref(isReadonly),
                class: "confirm-target-btn",
                onClick: handleConfirmTarget
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(isCurrentItemConfirmed) ? '已确认标的' : '确认标的'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.farmerName), 1)
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.orderNo), 1)
            ]),
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createElementVNode("span", _hoisted_74, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.targetNo), 1)
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.earNo), 1)
            ]),
            (showField.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.livestockAge), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.location), 1)
            ]),
            _createElementVNode("div", _hoisted_84, [
              _hoisted_85,
              _createElementVNode("span", _hoisted_86, [
                _createTextVNode(" 经度 " + _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.longitude), 1),
                _hoisted_87,
                _createTextVNode(" 纬度 " + _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.latitude), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _createElementVNode("span", _hoisted_90, _toDisplayString(_unref(simImages)[currentCompareIndex.value]?.collectDate), 1)
            ]),
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTypesLower), (type) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "button-container",
                      key: type.value
                    }, [
                      _createVNode(_component_el_button, {
                        class: _normalizeClass(['info-button', { active: activeTypeLower.value === type.value }]),
                        onClick: ($event: any) => (switchTypeLower(type.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createVNode(_component_el_button, {
              class: "nav-button prev",
              onClick: previousImageLower,
              disabled: !_unref(canGoPreviousLower)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowLeft))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "nav-button next",
              onClick: nextImageLower,
              disabled: !_unref(canGoNextLower)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowRight))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_97, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImagesLower), (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'pin-' + image.id,
                  class: "pin-container",
                  style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` }),
                  onClick: ($event: any) => (toggleFixLower(image))
                }, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("i", {
                      class: _normalizeClass(image.fixed ? 'fixed-icon-class' : 'pin-icon-class')
                    }, null, 2)
                  ])
                ], 12, _hoisted_98))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayImagesLower), (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: image.id,
                  class: "image-wrapper",
                  style: _normalizeStyle({ gridArea: `${Math.floor(index / 4) + 1} / ${index % 4 + 1}` })
                }, [
                  (image.type === 'VIDEO')
                    ? (_openBlock(), _createElementBlock("video", _hoisted_100, [
                        _createElementVNode("source", {
                          src: image.url,
                          type: "video/mp4"
                        }, null, 8, _hoisted_101),
                        _createTextVNode(" Your browser does not support the video tag. ")
                      ]))
                    : (_openBlock(), _createBlock(incImgSvg, {
                        key: 1,
                        class: "image-zoom-container",
                        "dialog-visible": false,
                        "img-width": "100%",
                        "img-src": image.url
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: image.url,
                            alt: 'Image ' + image.id
                          }, null, 8, _hoisted_102)
                        ]),
                        _: 2
                      }, 1032, ["img-src"]))
                ], 4))
              }), 128))
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, compareResult.value === 'REPEAT']
    ])
  ]))
}
}

})